module.exports = __webpack_public_path__ + "static/media/denglu-1.bbdea114.jpg";